import { Link, Typography } from "@material-ui/core";

export function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Copyright © "}
      <Link color="inherit" href="https://codetechs.co.uk/">
        iota-ML
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}
